/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
    object, string, bool, shape, array,
} from 'prop-types';
import DesktopMobile from '../../../helpers/DesktopMobile/DesktopMobile';
import NUpSimpleDesktop from './Desktop/NUpSimpleDesktop';
import NUpSimpleMobile from './Mobile/NUpSimpleMobile';
import uniqueId from '../../../helpers/contentstack/uniqueId';
import { getIsBot } from '../../../../state/ducks/App/App-Selectors';
import { getBrand } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import isDesktopMobileTablet from '../../../helpers/DesktopMobile/isDesktopMobileTablet';

export class NUpRow extends PureComponent {
    render() {
        const {
            data, headingAlignment, fixedMessage, isBot, brand,
        } = this.props;
        if (data.reference?.[0]) {
            const deviceType = isDesktopMobileTablet();
            let styleWrapper = null;
            if (deviceType === 'mobile') {
                styleWrapper = { 'background-color': '#F2F2F2', 'padding-bottom': '0px' };
            } else {
                styleWrapper = { 'background-color': '#F2F2F2', 'padding-bottom': '52px' };
            }
            const { dataUniqueId } = uniqueId(data.reference[0]?.unique_selector);
            const nupBackgroundStyle = brand?.code === 'PLA' ?  styleWrapper : '';
            return (
                <>
                    <div className="nup_block" style={nupBackgroundStyle}>

                        <DesktopMobile
                            desktop={() => <NUpSimpleDesktop data={data} headingAlignment={headingAlignment} fixedMessage={fixedMessage} data-uniqueid={dataUniqueId} isBot={isBot} />}
                            mobile={() => <NUpSimpleMobile data={data} headingAlignment={headingAlignment} fixedMessage={fixedMessage} data-uniqueid={dataUniqueId} isBot={isBot} />}
                        />

                    </div>
                </>
            );
        }
        return <></>;
    }
}

NUpRow.defaultProps = {
    headingAlignment: 'center',
    fixedMessage: false,
    isBot: false,
};

NUpRow.propTypes = {
    data: shape({
        entry: shape({
            linking: object,
            copy: array,
            cta_copy: array,
            background_image: object,
            background_image_mobile: object,
        }).isRequired,
        styles: object,
    }).isRequired,
    headingAlignment: string,
    fixedMessage: bool,
    isBot: bool,
    brand: object.isRequired,
};
const mapStateToProps = (state) => ({
    isBot: getIsBot(state),
    brand: getBrand(state),
});
const enhance = compose(
    connect(mapStateToProps),
);
export default enhance(NUpRow);
